export const b64JsonDecode = (str: string) => JSON.parse(atob(str))
